export default __webpack_public_path__ + "static/media/Bulb.cdc3db23.svg";